"use client"

import React from 'react';
import Image from 'next/image';

interface GradientLogoProps {
  size?: 'small' | 'medium' | 'large' | 'sidebar';
  className?: string;
}

const GradientLogo: React.FC<GradientLogoProps> = ({ 
  size = 'medium', 
  className = '' 
}) => {
  // Define sizes for the logo image
  const sizes = {
    small: { width: 120, height: 40 },
    medium: { width: 140, height: 47 },
    large: { width: 200, height: 67 },
    sidebar: { width: 180, height: 60 }, // Optimized for sidebar header
  };

  return (
    <div className={`${className} flex items-center justify-center`}>
      <Image
        src="/images/ES_logo.png"
        alt="EvidenceSync"
        width={sizes[size].width}
        height={sizes[size].height}
        className="object-contain w-auto h-auto max-w-full max-h-14"
        priority
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    </div>
  );
};

export default GradientLogo; 